export default __webpack_public_path__ + "static/IDA Quick Hit Brochure Update (Digital)-4d8ad3e4637d71472be589bc163bb9a0.pdf";